<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-dingding`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.04791 0.0136719C2.06594 0.0218996 6.29262 1.95056 9.18366 3.00879C12.0821 4.06923 14.6009 4.60786 14.2755 5.98047C14.2487 6.0965 14.1801 6.26915 14.084 6.47461H14.086L14.0753 6.49414C13.5147 7.6921 12.0528 10.043 12.0528 10.043L12.046 10.0264L11.6192 10.7705H13.6778L9.7442 15.999L10.6378 12.4424H9.01666L9.58014 10.0908C9.12514 10.2003 8.58519 10.3502 7.94733 10.5557C7.93898 10.5605 7.07776 11.0531 5.46295 9.58496C5.46295 9.58496 4.36864 8.62094 5.00397 8.38086C5.27352 8.27821 6.31286 8.14651 7.13092 8.03711C8.23849 7.88776 8.91803 7.80859 8.91803 7.80859C8.91803 7.80859 5.50798 7.85915 4.69928 7.73242C3.89051 7.60558 2.86446 6.25522 2.64557 5.06934C2.6408 5.06005 2.31584 4.42069 3.37311 4.72656C4.43826 5.03486 8.84577 5.92773 8.84577 5.92773C8.84577 5.92773 3.1184 4.17166 2.73151 3.74121C2.34989 3.31443 1.60924 1.40141 1.70514 0.227539C1.70514 0.227539 1.74631 -0.0663227 2.04791 0.0136719Z" :fill="useCurrentColor ? 'currentColor' : '#007FFF'"/></svg>
</template>
<script>

export default {
  name: 'IconColorDingding',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
